import { useSelector } from "react-redux"
import "./WishOwner.scss"
import { wishSelectors } from "@/slices/wishSlice"
import { getWishListForWish } from "@/services/clientWishService"
import { settingsSelectors } from "@/slices/settingsSlice"

interface IWishOwnerProps {
  wish: IWishDto
}

export const WishOwner = ({ wish }: IWishOwnerProps): JSX.Element => {
  const wishLists = useSelector(wishSelectors.wishLists)
  const wishList = getWishListForWish(wish.id, wishLists)

  const settings = useSelector(settingsSelectors.settings)

  if (!wishList) {
    return <></>
  }

  const color =
    wishList.owner === "marina" ? "red" : wishList.owner === "christian" ? "blue" : "green"
  return (
    <div className="wish-owner">
      {!!wish.url && (
        <div className="wish-owner__store">
          <img
            src="/images/store-icon.png"
            onClick={() => {
              window.open(wish.url, "_blank")?.focus()
            }}
          />
        </div>
      )}
      {settings?.themeType === "christmas" && (
        <div className="wish-owner__letter" style={{ color: color }}>
          {wishList.owner === "marina"
            ? "Marina"
            : wishList.owner === "christian"
              ? "Christian"
              : "Fælles"}
        </div>
      )}
    </div>
  )
}
